import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'auditAction'
})
export class AuditActionPipe implements PipeTransform {

  transform(value: string): string {
    switch (value) {

      case 'edit':
      case 'change':
        return 'Änderung';

      case 'create':
        return 'Erstellt';

      case 'delete':
        return 'Gelöscht';

      default:
        return value;
    }
  }

}
